$(document).ready(function(){
  $('.logo-list__wrapper').flickity({
    cellAlign: 'left',
    contain: true,
    autoPlay: true,
    autoPlay: 1500,
    wrapAround: true
  });

  $('.sidebar-block__heading').click(function(){
      $(this).parents('.sidebar-toggle-option').siblings('.sidebar-block__content').slideToggle();
      $(this).parents('.sidebar-toggle-option').toggleClass('active');
  })
  $('.swatch__option').click(function(){
    var tabId = $(this).data('tab-id');
    //console.log(tabId);
    $('.spec-weight').removeClass('active');
    $('#tab-'+ tabId).addClass('active');
  })

  if ( matchMedia('screen and (max-width: 798px)').matches ) {
    $('.product-gallery__main-wrap').flickity({
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true
    });
  }
  $('.product-accordion').click(function(){
      $(this).toggleClass('active');
  })
}) 